import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Link} from '@udemy/react-core-components';

import styles from './career-stats-citations.module.less';

const CITATION_LINKS = {
    jobsForTheFuture: 'https://www.jff.org/idea/skills-and-talent-development-in-the-age-of-ai/',
    pwc: 'https://www.pwc.com/gx/en/services/ai/ai-jobs-barometer.html',
    workday:
        'https://forms.workday.com/en-us/reports/elevating-human-potential/form.html?step=step1_default',
} as const;

export const CareerStatsCitations = () => {
    const {gettext} = useI18n();

    return (
        <ol className={styles.list}>
            <li className={styles.item}>
                {'¹ '}
                {gettext('Jobs for the Future, ')}
                <Link
                    to={CITATION_LINKS.jobsForTheFuture}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className={'ud-link-underline'}
                >
                    {gettext('Skills and Talent Development in the Age of AI')}
                </Link>
                {gettext(' (2025). Data reflects changes between December 2022 and December 2024.')}
            </li>
            <li className={styles.item}>
                {'² '}
                {gettext('PwC. ')}
                <Link
                    to={CITATION_LINKS.pwc}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className={'ud-link-underline'}
                >
                    {gettext('The Fearless Future: 2025 Global AI Jobs Barometer')}
                </Link>
                {gettext(' (2025)')}
            </li>
            <li className={styles.item}>
                {'³ '}
                {gettext('Workday. ')}
                <Link
                    to={CITATION_LINKS.workday}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className={'ud-link-underline'}
                >
                    {gettext('Elevating Human Potential: The AI Skills Revolution')}
                </Link>
                {gettext(' (2025)')}
            </li>
        </ol>
    );
};
